import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Typography, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
// Internal dependencies
import { axiosClient } from '../axios';
import { CLIENT_ENDPOINTS } from "../constants/clientEndpoints";
import { SelectSG } from "../components";
import { LOG_LEVELS, SERVICES, ENDPOINTS } from '../constants';
import { UserContext } from '../auth';
/** Brand Voice Dialog */
const BrandVoiceDialog = ({ open, onClose, value, onSave, option }) => {
    // Get user credential
    const user = useContext(UserContext);
    // Use translation
    const { t } = useTranslation();
    // Use navigate from react router dom
    const navigate = useNavigate();
    const [selectedBrandVoiceOption, setSelectedBrandVoiceOption] = useState(value);
    const handleAddBrandVoice = () => {
        var _a, _b, _c;
        try {
            navigate(CLIENT_ENDPOINTS.BRAND_VOICE);
        }
        catch (err) {
            axiosClient.post(`${process.env.LOGGER_SERVER_URL}${ENDPOINTS.LOGGER}${ENDPOINTS.LOG}`, {
                level: LOG_LEVELS.ERROR,
                logMessage: err.message,
                metadata: {
                    env: process.env.ENV,
                    service: SERVICES.AI_CHAT,
                    userId: undefined,
                    email: undefined,
                    userAgent: navigator.userAgent,
                },
            });
            // Check if the error is from axios
            if ((_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status) {
                // If yes, notify user with the server error message
                toast.error((_c = (_b = err === null || err === void 0 ? void 0 : err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message);
                return;
            }
            ;
            toast.error(t('Something went wrong. We are figuring it out.'));
        }
        ;
    };
    /**
     * Handle save brand voice
     */
    const handleSaveBrandVoice = () => {
        onSave(selectedBrandVoiceOption);
    };
    useEffect(() => {
        setSelectedBrandVoiceOption(value);
    }, [open]);
    return _jsxs(Dialog
    // Output Brand Voice dialog
    , Object.assign({ 
        // Output Brand Voice dialog
        sx: {
            '& .MuiDialog-paper': {
                backgroundColor: '#ffffff',
                borderRadius: '1rem',
                maxWidth: '384px',
                width: {
                    xs: '90%',
                    md: '50%',
                },
            }
        }, open: open, onClose: onClose }, { children: [_jsx(DialogTitle, { children: t('Select Brand Voice') }), _jsx(Box, { children: _jsx(DialogContent, Object.assign({ sx: { padding: '0.5rem 1.5rem' } }, { children: _jsx(SelectSG
                    // Brand Voice select
                    , { 
                        // Brand Voice select
                        variant: "outlined", name: selectedBrandVoiceOption.title, label: "Brand Voice", items: option, value: selectedBrandVoiceOption.value, onChange: (event) => {
                            const data = event.target;
                            const brandVoice = option.find((item) => item.value.toString() === data.value.toString());
                            if (brandVoice) {
                                setSelectedBrandVoiceOption(brandVoice);
                            }
                            ;
                        } }) })) }), _jsxs(DialogActions, Object.assign({ sx: {
                    padding: '0 1.5rem 1.5rem',
                } }, { children: [_jsx(Button, Object.assign({ variant: 'outlined', sx: {
                            padding: '0.625rem 1.5rem',
                            textTransform: 'none',
                            background: '#FFFFFF',
                            borderRadius: '100px',
                            border: '1px solid #707974',
                        }, onClick: handleAddBrandVoice }, { children: _jsx(Box, Object.assign({ sx: {
                                overflow: 'hidden',
                                width: '100%',
                                boxSizing: 'border-box',
                            } }, { children: _jsx(Typography, Object.assign({ sx: {
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    boxSizing: 'border-box',
                                    fontWeight: '500',
                                    fontSize: '0.875rem',
                                    lineHeight: '1.25rem',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    letterSpacing: '0.00625rem',
                                    color: '#006B54',
                                } }, { children: t('Add Brand Voice') })) })) })), _jsx(Button, Object.assign({ variant: 'contained', sx: {
                            fontWeight: '500',
                            fontSize: '0.875rem',
                            lineHeight: '1.25rem',
                            alignItems: 'center',
                            textAlign: 'center',
                            letterSpacing: '0.00625rem',
                            padding: '0.625rem 1.5rem',
                            background: '#006B54',
                            textTransform: 'none',
                            color: '#FFFFFF',
                            borderRadius: '100px',
                            whiteSpace: 'nowrap',
                        }, onClick: handleSaveBrandVoice }, { children: t('Save') }))] }))] }));
};
export default BrandVoiceDialog;
